import { useState, useCallback } from "react";

let toastIdCounter = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, duration = 3000) => {
    const id = toastIdCounter++;
    const newToast = { id, message, isVisible: true };

    setToasts((prev) => [...prev, newToast]);

    // Step 1: ซ่อนก่อน
    setTimeout(() => {
      setToasts((prev) =>
        prev.map((toast) =>
          toast.id === id ? { ...toast, isVisible: false } : toast
        )
      );
    }, duration);

    // Step 2: แล้วค่อยลบจริงหลัง animation จบ
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration + 300); // 300ms คือเวลา fade out
  }, []);

  const Toasts = (
    <div className="toast_container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast ${
            toast.isVisible ? "toast_slide_in" : "toast_slide_out"
          }`}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );

  return { showToast, Toasts };
}
